import React, { useState, createContext } from 'react';
import { IntlProvider } from 'react-intl';

import English from '../languages/en.json';
import Russian from '../languages/ru.json';

export const Context = createContext();
const local = navigator.language.slice(0, 2);
let lang;
switch (local) {
  case 'en':
    lang = English;
    break;
  case 'ru':
    lang = Russian;
    break;
  default:
    lang = English;
}

const AppContext = (props) => {
  const [locale, setLocale] = useState(local);
  const [messages, setMessages] = useState(lang);

  const selectLanguage = (newLocale) => {
    setLocale(newLocale);
    switch (newLocale) {
      case 'en':
        setMessages(English);
        break;
      case 'ru':
        setMessages(Russian);
        break;
      default:
        setMessages(English);
    }
  };
  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {props.children}
      </IntlProvider>
    </Context.Provider>
  )
}

export default AppContext;
